import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import siteLogo from '../assets/logo_white.png';

// Ödeme ikonlarını projenize dahil edin
import americanExpress from '../assets/american-express.svg';
import visa from '../assets/visa.svg';
import mastercard from '../assets/mastercard.svg';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="main-footer-creative">
            <div className="footer-container">
          
                <div className="footer-column brand">
                    <img src={siteLogo} alt="Quadlingua Logo" className="footer-logo" />
                    <p>{t('footer_about_text', 'Profesyonel, hızlı ve güvenilir online çeviri hizmetleri.')}</p>
                    <div className="social-icons">
                        <a href={t('social_linkedin_url')} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
						<a href={t('social_twitter_url')} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="fa-brands fa-twitter"></i></a>
						<a href={t('social_bluesky_url')} target="_blank" rel="noopener noreferrer" aria-label="Bluesky"><i className="fa-brands fa-bluesky"></i></a>
						<a href={t('social_facebook_url')} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
                        <a href={t('social_instagram_url')} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa-brands fa-instagram"></i></a>

                    </div>
                </div>

        
                <div className="footer-column links">
                    <h4>{t('services', 'Hizmetler')}</h4>
                    <Link to="/services">{t('legal', 'Hukuki')}</Link>
                    <Link to="/services">{t('medical', 'Medikal')}</Link>
                    <Link to="/services">{t('technical', 'Teknik')}</Link>
                    <Link to="/services">{t('academic', 'Akademik')}</Link>
                    <Link to="/services">{t('website_localization', 'Web Site Lokalizasyonu')}</Link>
                </div>

                <div className="footer-column links">
                    <h4>{t('company', 'Şirket')}</h4>
                    <Link to="/about">{t('about_us', 'Hakkımızda')}</Link>
                    <Link to="/contact">{t('contact_us', 'İletişim')}</Link>
                    <Link to="/faq">{t('faq', 'SSS')}</Link>
                    <Link to="/privacy-policy">{t('privacy_policy', 'Gizlilik Politikası')}</Link>
                </div>


                <div className="footer-column links">
                    <h4>{t('get_involved', 'Katılın')}</h4>
                    <Link to="/register-translator">{t('join_as_translator', 'Çevirmen Olarak Katıl')}</Link>
                </div>
            </div>

     
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Quadlingua. {t('footer_copyright', 'Tüm Hakları Saklıdır.')}</p>
                <div className="payment-icons">
                   
                    <img src={mastercard} alt="Mastercard" title="Mastercard" />
					<img src={visa} alt="Visa" title="Visa" />        
					 <img src={americanExpress} alt="American Express" title="American Express" />
                </div>
            </div>
        </footer>
    );
};

export default Footer;